export default function FlightDestinations() {
  return (
    <>
   <section id="FlightDestinations">
      <div className="container-fluid" data-aos="fade-up">
        <div className="section-header">
          <h2>Our Flight Destinations</h2>
          <p>Find Cheap Flight Destinations For Your Memorable Travel</p>
        </div>
      </div>
      <div className="container-fluid venue-gallery-container" data-aos="fade-up" data-aos-delay="100">
        <div className="row g-0">

          <div className="col-lg-3 col-md-4">
            <div className="venue-gallery">
                <img src={"../assets/img/flights/air-travel (7).avif"} alt="" className="img-fluid" />
            </div>
          </div>

          <div className="col-lg-3 col-md-4">
            <div className="venue-gallery">
                <img src={"../assets/img/flights/air-travel (8).avif"} alt="" className="img-fluid" />
            </div>
          </div>

          <div className="col-lg-3 col-md-4">
            <div className="venue-gallery">
                <img src={"../assets/img/flights/air-travel (9).avif"} alt="" className="img-fluid" />
            </div>
          </div>

          <div className="col-lg-3 col-md-4">
            <div className="venue-gallery">
                <img src={"../assets/img/flights/air-travel (10).avif"} alt="" className="img-fluid" />
            </div>
          </div>

          <div className="col-lg-3 col-md-4">
            <div className="venue-gallery">
                <img src={"../assets/img/flights/air-travel (11).avif"} alt="" className="img-fluid" />
            </div>
          </div>

          <div className="col-lg-3 col-md-4">
            <div className="venue-gallery">
                <img src={"../assets/img/flights/air-travel (13).avif"} alt="" className="img-fluid" />
            </div>
          </div>

          <div className="col-lg-3 col-md-4">
            <div className="venue-gallery">
                <img src={"../assets/img/flights/air-travel (14).avif"} alt="" className="img-fluid" />
            </div>
          </div>

          <div className="col-lg-3 col-md-4">
            <div className="venue-gallery">
                <img src={"../assets/img/flights/air-travel (15).avif"} alt="" className="img-fluid" />
            </div>
          </div>
        </div>
      </div>
    </section>
    </>
  );
}
